module.exports = __webpack_public_path__ + "Roboto-Regular.0d248fece6f093412c3d.woff";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/assets/font/roboto/Roboto-Regular.woff
// module id = ../../../../../src/assets/font/roboto/Roboto-Regular.woff
// module chunks = 2